import listUtil from './listUtil'
import dateUtil from '../lib/dateUtil'

let reportUtil = {}

function calculateManagedSpaceRatios (row) {
  listUtil.addRatioToObject(row, 'ave_occupant_in_used_periods', 'total_occupant', 'periods_used')
  listUtil.addRatioToObject(row, 'ave_occupant_in_all_periods', 'total_occupant', 'periods_measured')
  listUtil.addRatioToObject(row, 'percent_occupancy_in_used_periods', 'total_occupant', 'slots_in_used_periods', true)
  listUtil.addRatioToObject(row, 'percent_occupancy_all_periods', 'total_occupant', 'slots_in_all_periods', true)
  listUtil.addRatioToObject(row, 'percent_frequency_of_use', 'periods_used', 'periods_measured', true)
  listUtil.addProductToObject(row, 'percentage_utilisation', 'percent_frequency_of_use', 'percent_occupancy_all_periods', true)
}

function calculateEnvironmentalRatios (row) {
  listUtil.addRatioToObject(row, 'temp_avg', 'temp_sum', 'temp_count')
  listUtil.addRatioToObject(row, 'co2_avg', 'co2_sum', 'co2_count')
  listUtil.addRatioToObject(row, 'humid_avg', 'humid_sum', 'humid_count')
  listUtil.addRatioToObject(row, 'lux_avg', 'lux_sum', 'lux_count')
  listUtil.addRatioToObject(row, 'snd_avg', 'snd_sum', 'snd_count')
  listUtil.addRatioToObject(row, 'tvoc_avg', 'tvoc_sum', 'tvoc_count')
  listUtil.addRatioToObject(row, 'pressure_avg', 'pressure_sum', 'pressure_count')
}

reportUtil.addCalculatedOccupancyUtilisationFields = function (data) {
  console.log('addCalculatedOccupancyUtilisationFields')
  for (let row of data) {
    calculateManagedSpaceRatios(row)
    calculateEnvironmentalRatios(row)
  }
}

reportUtil.addManagedSpaceNames = function (data) {
  // console.log('add mananged space names')
  // for (let row of data) {
  //   if (row['managedspace_id']) {
  //     row['managedspace_name'] = 'TBD'
  //   }
  // }
}

reportUtil.addDaysOfWeekNames = function (data) {
  console.log('add day of week names')
  for (let row of data) {
    let day = row['day_of_week']
    if (day) {
      row['day_name'] = dateUtil.daysOfWeekDict[day].short
    }
  }
}

reportUtil.replaceNulls = function (data, column) {
  console.log('replace nulls in column', column)
  for (let row of data) {
    if (row[column] === null) {
      row[column] = '-Not Set-'
    }
  }
}

reportUtil.getDefaultVuetifyTableHeader = function (list) {
  console.log('getDefaultVuetifyTableHeader')
  let result = []

  if (!list) {
    return result
  }

  if (list.length === 0) {
    return result
  }

  for (let key of Object.keys(list[0])) {
    listUtil.addTableHeaderRow(result, key)
  }
  return result
}

reportUtil.addOccupanyAndUtililizationGroupX2 = function (groups) {
  for (let outerKey in groups) {
    for (let innerKey in groups[outerKey]) {
      let row = groups[outerKey][innerKey]
      calculateManagedSpaceRatios(row)
      calculateEnvironmentalRatios(row)
    }
  }
}

reportUtil.groupX2AggregateManagedSpaceValuesReplaceNull = function (values, group1, group2, nullReplace) {
  let groups = []

  for (let row of values) {
    // console.log(row)

    let group1Value = row[group1]
    if (!group1Value) {
      group1Value = nullReplace
    }
    let group2Value = row[group2]
    if (!group2Value) {
      group2Value = nullReplace
    }

    // console.log('Groups: ' + group1Value + ' ' + group2Value)

    if (!groups[group1Value]) {
      groups[group1Value] = []
    }
    if (!groups[group1Value][group2Value]) {
      groups[group1Value][group2Value] = {
        group1: group1Value,
        group2: group2Value,
        min_occupant: row.min_occupant,
        max_occupant: row.max_occupant,
        periods_used: row.periods_used,
        periods_measured: row.periods_measured,
        slots_in_used_periods: row.slots_in_used_periods,
        slots_in_all_periods: row.slots_in_all_periods,
        total_occupant: row.total_occupant,
        temp_sum: row.temp_sum,
        temp_count: row.temp_count,
        co2_sum: row.co2_sum,
        co2_count: row.co2_count,
        humid_sum: row.humid_sum,
        humid_count: row.humid_count,
        lux_sum: row.lux_sum,
        lux_count: row.lux_count,
        snd_sum: row.snd_sum,
        snd_count: row.snd_count,
        tvoc_sum: row.tvoc_sum,
        tvoc_count: row.tvoc_count,
        pressure_sum: row.pressure_sum,
        pressure_count: row.pressure_count,
        temp_min: row.temp_min,
        temp_max: row.temp_max,
        co2_min: row.co2_min,
        co2_max: row.co2_max,
        humid_min: row.humid_min,
        humid_max: row.humid_max,
        lux_min: row.lux_min,
        lux_max: row.lux_max,
        snd_min: row.snd_min,
        snd_max: row.snd_max,
        tvoc_min: row.tvoc_min,
        tvoc_max: row.tvoc_max,
        pressure_min: row.pressure_min,
        pressure_max: row.pressure_max,
        seat_hours: row.seat_hours
      }
      // console.log('Init ' + JSON.stringify(groups[group1Value][group2Value]))
    } else {
      let agg = groups[group1Value][group2Value]
      groups[group1Value][group2Value] = {
        group1: group1Value,
        group2: group2Value,
        min_occupant: Math.min(row.min_occupant, agg.min_occupant),
        max_occupant: Math.max(row.max_occupant, agg.max_occupant),
        periods_used: row.periods_used + agg.periods_used,
        periods_measured: row.periods_measured + agg.periods_measured,
        slots_in_used_periods: row.slots_in_used_periods + agg.slots_in_used_periods,
        slots_in_all_periods: row.slots_in_all_periods + agg.slots_in_all_periods,
        total_occupant: row.total_occupant + agg.total_occupant,
        temp_sum: row.temp_sum + agg.temp_sum,
        temp_count: row.temp_count + agg.temp_count,
        seat_hours: row.seat_hours + agg.seat_hours,

        co2_sum: row.co2_sum + agg.co2_sum,
        co2_count: row.co2_count + agg.co2_count,
        humid_sum: row.humid_sum + agg.humid_sum,
        humid_count: row.humid_count + agg.humid_count,
        lux_sum: row.lux_sum + agg.lux_sum,
        lux_count: row.lux_count + agg.lux_count,
        snd_sum: row.snd_sum + agg.snd_sum,
        snd_count: row.snd_count + agg.snd_count,
        tvoc_sum: row.tvoc_sum + agg.tvoc_sum,
        tvoc_count: row.tvoc_count + agg.tvoc_count,
        pressure_sum: row.pressure_sum + agg.pressure_sum,
        pressure_count: row.pressure_count + agg.pressure_count,

        temp_min: Math.min(row.temp_min, agg.temp_min),
        temp_max: Math.max(row.temp_max, agg.temp_max),
        co2_min: Math.min(row.co2_min, agg.co2_min),
        co2_max: Math.max(row.co2_max, agg.co2_max),
        humid_min: Math.min(row.humid_min, agg.humid_min),
        humid_max: Math.max(row.humid_max, agg.humid_max),
        lux_min: Math.min(row.lux_min, agg.lux_min),
        lux_max: Math.max(row.lux_max, agg.lux_max),
        snd_min: Math.min(row.snd_min, agg.snd_min),
        snd_max: Math.max(row.snd_max, agg.snd_max),
        tvoc_min: Math.min(row.tvoc_min, agg.tvoc_min),
        tvoc_max: Math.max(row.tvoc_max, agg.tvoc_max),
        pressure_min: Math.min(row.pressure_min, agg.pressure_min),
        pressure_max: Math.max(row.pressure_max, agg.pressure_max)
      }
      // console.log('Acc ' + JSON.stringify(groups[group1Value][group2Value]))
    }
  }

  return groups
}

export default reportUtil
